import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import { Grid } from "@material-ui/core";
import ToastModal from "views/components/ToastModal";
import { silverRateData } from "assets/properties/properties";
import { commonButton } from "assets/properties/properties";
import { toastAction } from "assets/properties/properties";
import { parseAndSetFlag } from "utils/Utils";

const SilverMasterCreate = ({ classes,featureFlagState }) => {
  const navigate = useNavigate();
  const [finenesscode, setFinenessCode] = useState("999");
  const [lendingrateError, setLendingrateError] = useState(false);
  const [lendingrate, setLendingRate] = useState("");
  const [fixedLendingrate, setFixedLendingRate] = useState("");
  const [marketRateError, setMarketRateError] = useState(false);
  const [marketRate, setMarketRate] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [redirectURL, setRedirectURL] = useState("");
  const [disableSubmit, setDisableSubmit]= useState(false)
  const checkLendingRateValidation = parseAndSetFlag(featureFlagState?.checkLendingRateValidation)
  useEffect(() => {
    (async () => {
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.SILVER_MASTER_FIND_PUTIRY,
        authToken: authToken,
      });
      setFinenessCode("999");
      setLendingRate("" + result?.data?.lendingPrice || "");
      setMarketRate(""+ result?.data?.marketPrice || "")
      await GetFixedLendingRate()
    })();
  }, []);

  const GetFixedLendingRate = async ()=>{
    const result = await apiHandler({
      url: endpoint.SILVER_MASTERLENDING_RATE,
      authToken: authToken,
      method:"POST",
    });
    setCallInProgress(false);
    setFixedLendingRate("" + result?.data?.lendingPrice || "");
  }
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };

  const isValidated = () => {
    if (lendingrate === "") {
      setLendingrateError(true);
      return false;
    } else if(marketRate === ""){
      setMarketRateError(true);
      return false;
    } else {
      return true;
    }
  };

  const handleCreateGoldRateSubmit = async () => {
    if (isValidated()) {
      //ADMIN_GOLDRATE_UPDATE
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.SILVER_MASTER_UPDATE,
        method: "POST",
        authToken: authToken,
        data: {
          marketPrice: marketRate?.replace(/\s/g, ''),
          lendingPrice: lendingrate?.replace(/\s/g, ''),
          currencyCode: "INR",
        },
      });
      setCallInProgress(false);
       if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);

        return;
      } else {
        toastUpdate(toastAction?.success, silverRateData?.successMsg, true);
        setRedirectURL(silverRateData?.mainUrl);
      }
    }
  };
  const handleCancelGoldRate = () => {
    navigate(silverRateData?.mainUrl);
  };

  const handleLendingRate = (e) => {
    if(Number(e) > Number(fixedLendingrate) && checkLendingRateValidation){
      toastUpdate(toastAction?.error, `${silverRateData?.lendingRateError} ${fixedLendingrate}`, true);
      setDisableSubmit(true)
    }else{
      setLendingRate(e);
      setDisableSubmit(false)
    }
  }
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={silverRateData?.label}
          button1={commonButton?.button1}
          button2={commonButton?.button2}
          button1click={handleCreateGoldRateSubmit}
          disabled1={disableSubmit}
          button2click={handleCancelGoldRate}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
      <Grid container className={classes.inputFieldContainer}>
        <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
            label="Fineness Code"
            required
            id="fitness_code"
            value={finenesscode}
            disabled
          />
        </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
            label="Lending Rate"
            required
            error={lendingrateError}
            id="lending_rate"
            value={lendingrate}
            setState={setLendingRate}
            setBlur={handleLendingRate}
            type="number"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
            label="Market Rate"
            required
            error={marketRateError}
            id="market_rate"
            value={marketRate}
            setState={setMarketRate}
            type="number"
          />
        </Grid>
      </Grid>
      </Grid >
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </Grid >
  );
};

SilverMasterCreate.propTypes = {
  classes: PropTypes.object,
};

export default SilverMasterCreate;
